import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { AppCard } from '@/layout/AppComponents';
import styled from 'styled-components';
import Scrollbars from 'react-custom-scrollbars';
import InformationTab from './InformationTab';
import AssessmentTab from './AssessmentTab';
import ControlTab from './ControlTab/ControlTab';
import ActionPlanTab from './ActionPlanTab/ActionPlanTab';

export default function TotalEnergiesRiskRiskExpandedContainer({
  elementID,
  active,
}) {
  const [activeTab, setActiveTab] = useState(active || 'controls');

  return (
    <Container
      bodyClassName="p-0 mt-2 rs-expanded-card-body"
      className="rs-expanded-card"
    >
      <Tabs defaultActiveKey={activeTab} onSelect={(v) => setActiveTab(v)}>
        <Tab
          eventKey="information"
          title="Información"
          className="p-3 border border-top-0 bg-white"
        >
          {activeTab === 'information' && (
            <Scrollbars style={{ height: '400px' }}>
              <InformationTab elementID={elementID} />
            </Scrollbars>
          )}
        </Tab>
        <Tab
          eventKey="controls"
          title="Controles"
          className="pt-3 border border-top-0 bg-white"
        >
          <Scrollbars style={{ height: '400px' }}>
            <ControlTab elementID={elementID} />
          </Scrollbars>
        </Tab>
        <Tab
          eventKey="assessment"
          title="Valoración"
          className="p-3 border border-top-0 bg-white"
        >
          <Scrollbars style={{ height: '400px' }}>
            <AssessmentTab elementID={elementID} />
          </Scrollbars>
        </Tab>
        <Tab
          eventKey="actionPlans"
          title="Planes de acción"
          className="pt-3 border border-top-0 bg-white"
        >
          <Scrollbars style={{ height: '400px' }}>
            <ActionPlanTab elementID={elementID} />
          </Scrollbars>
        </Tab>
      </Tabs>
    </Container>
  );
}

const Container = styled(AppCard)`
  .rs-expanded {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
  .rs-expanded-card-body {
    min-height: 120px;
  }
`;
